// import { base } from '../base';
// const { color } = base;
// export const charts = {
//   ...base,
//   charts: {
//     xColor: color.c0014,
//     yColor: color.c0012,
//     axisLineColor: color.c0031,
//     barColorList: [color.c0002, color.c0003, color.c0004, color.c0027],
//     lineColorList: [color.c0006, color.c0009, color.c0011],
//     pieColorList: [
//       color.c0001,
//       color.c0002,
//       color.c0003,
//       color.c0004,
//       color.c0005,
//     ],
//   },
// };
import { brandCodeMap } from '@/constants';
import { base } from '../base';

const chartTheme = {};
for (const item of Object.keys(brandCodeMap)) {
  chartTheme[item] = {
    charts: {
      xColor: base[item]?.chartColor.c0001,
      yColor: base[item]?.chartColor.c0002,
      axisLineColor: base[item]?.chartColor.c0003, // '#3C424820'
      //柱状图的颜色列表
      barColorList: [
        base[item]?.chartColor.c0005,
        base[item]?.chartColor.c0006,
        base[item]?.chartColor.c0007,
        base[item]?.chartColor.c0008,
      ],
      //折线图的颜色列表
      lineColorList: [
        // base[item]?.chartColor.c0012,
        base[item]?.chartColor.c0021,
        base[item]?.chartColor.c0022,
        base[item]?.chartColor.c0023,
        base[item]?.chartColor.c0024,
        base[item]?.chartColor.c0025,
        base[item]?.chartColor.c0026,
        base[item]?.chartColor.c0027,
        base[item]?.chartColor.c0028,
      ],
      lineColorAreaList: [
        base[item]?.chartColor.c0004,
        base[item]?.chartColor.c0006,
        base[item]?.chartColor.c0030,
        base[item]?.chartColor.c0007,
      ],
      //饼图的颜色列表
      pieColorList: [
        base[item]?.chartColor.c0004,
        base[item]?.chartColor.c0005,
        base[item]?.chartColor.c0006,
        base[item]?.chartColor.c0007,
        base[item]?.chartColor.c0008,
      ],
      //饼图的颜色列表多
      pieColorListMore: [
        base[item]?.chartColor.c0013,
        base[item]?.chartColor.c0014,
        base[item]?.chartColor.c0015,
        base[item]?.chartColor.c0016,
        base[item]?.chartColor.c0017,
        base[item]?.chartColor.c0018,
        base[item]?.chartColor.c0019,
      ],
      // 矩形树图颜色
      gaugeColorList: [
        base[item]?.chartColor.c0005,
        base[item]?.chartColor.c0006,
        base[item]?.chartColor.c0007,
        base[item]?.chartColor.c0008,
        base[item]?.chartColor.c0009,
        base[item]?.chartColor.c0010,
        base[item]?.chartColor.c0012,
      ],
      //红蓝对比
      contrastColor: [
        base[item]?.chartColor.c0012,
        base[item]?.chartColor.c0010,
      ],
    },
  };
}

export const charts = chartTheme;
